export const USER_STATUS = {
  UNAUTH: "unauth",
  UNVERIFIED: "unverified",
  VERIFIED: "verified",
  PREMIUM: "premium",
};

export const LANDING_BY_STATUS = {
  [USER_STATUS.UNAUTH]: "/", // goes through root loader (age/lang/home)
  [USER_STATUS.UNVERIFIED]: "/verify", // placeholder page
  [USER_STATUS.VERIFIED]: "/dashboard",
  [USER_STATUS.PREMIUM]: "/dashboard", // or '/premium'
};
